export const scrollToElement = (elementId) => {
  // console.log(`[scrollToElement] Attempting to scroll to: ${elementId}`);
  const container = document.querySelector(".slides-container");
  const element = document.getElementById(elementId);
  if (element && container) {
    const scrollTop =
      container.scrollTop + element.getBoundingClientRect().top - container.getBoundingClientRect().top - 8;
    const scrollLeft =
      container.scrollLeft + element.getBoundingClientRect().left - container.getBoundingClientRect().left - 8;

    container.scrollTo({
      top: scrollTop,
      left: scrollLeft,
      behavior: "smooth",
    });
    
    // Also update the URL hash to keep it in sync with the scroll
    if (window.location.hash.slice(1) !== elementId) {
      // console.log(`[scrollToElement] Updating hash to: #${elementId}`);
      window.history.pushState(null, null, `#${elementId}`);
    }
  } else {
    // console.error(`[scrollToElement] Failed to find element with ID: ${elementId} or container.`);
  }
};

export const initializeScroll = (viewData, isPresentationMode) => {
  const container = document.querySelector(".slides-container");

  // Check if the URL hash exists, viewData is loaded and scrollTo is not set
  if (window.location.hash && viewData) {
    scrollToElement(window.location.hash.slice(1));
  }

  const handleKeyDown = (event) => {
    // console.log(`[handleKeyDown] key: ${event.key}, shift held: ${event.shiftKey}`);
    if (!viewData?.slides?.length || !event.shiftKey) return;

    // Helper to get full component objects for a slide from viewData
    const getComponentsForSlide = (slide) => {
      if (!slide || !slide.components || !viewData.contents) return [];
      return slide.components
        .map((id) => viewData.contents.find((c) => c.id === id))
        .filter((c) => c && c.id); // Filter out nulls and ensure component has ID
    };

    const getCurrentLocation = () => {
      const currentHash = window.location.hash.slice(1);
      if (!currentHash && viewData.slides.length > 0) {
        return { slide: viewData.slides[0], slideIndex: 0, component: null, componentIndex: -1 };
      }

      for (let i = 0; i < viewData.slides.length; i++) {
        const slide = viewData.slides[i];
        if (slide.id === currentHash) {
          return { slide: slide, slideIndex: i, component: null, componentIndex: -1 };
        }
        const components = getComponentsForSlide(slide);
        const compIndex = components.findIndex((c) => c.id === currentHash);
        if (compIndex !== -1) {
          return { slide: slide, slideIndex: i, component: components[compIndex], componentIndex: compIndex };
        }
      }

      // Fallback
      return { slide: viewData.slides[0], slideIndex: 0, component: null, componentIndex: -1 };
    };

    const { slide: currentSlide, slideIndex: currentSlideIndex, componentIndex: currentComponentIndex } =
      getCurrentLocation();

    if (!currentSlide) return;

    const navigateSlides = (direction) => {
      event.preventDefault();
      const nextSlideIndex = direction === "right" ? currentSlideIndex + 1 : currentSlideIndex - 1;
      if (nextSlideIndex >= 0 && nextSlideIndex < viewData.slides.length) {
        scrollToElement(viewData.slides[nextSlideIndex].id);
      }
    };

    const navigateComponents = (direction) => {
      event.preventDefault();
      const componentsOnCurrentSlide = getComponentsForSlide(currentSlide);

      if (direction === "down") {
        const isNotLastComponent = currentComponentIndex < componentsOnCurrentSlide.length - 1;
        if (componentsOnCurrentSlide.length > 0 && isNotLastComponent) {
          // This handles moving from a slide to the first component (index -1 -> 0)
          // and from a component to the next one.
          scrollToElement(componentsOnCurrentSlide[currentComponentIndex + 1].id);
        } else {
          // At the last component or on a slide with no components, find the next slide with components.
          for (let i = currentSlideIndex + 1; i < viewData.slides.length; i++) {
            const nextComponents = getComponentsForSlide(viewData.slides[i]);
            if (nextComponents.length > 0) {
              scrollToElement(nextComponents[0].id);
              return;
            }
          }
        }
      } else if (direction === "up") {
        if (currentComponentIndex > 0) {
          // From a component to the previous one on the same slide.
          scrollToElement(componentsOnCurrentSlide[currentComponentIndex - 1].id);
        } else if (currentComponentIndex === 0) {
          // From the first component of a slide up to the slide itself.
          scrollToElement(currentSlide.id);
        } else {
          // From a slide (index -1), find the previous slide with components.
          for (let i = currentSlideIndex - 1; i >= 0; i--) {
            const prevComponents = getComponentsForSlide(viewData.slides[i]);
            if (prevComponents.length > 0) {
              scrollToElement(prevComponents[prevComponents.length - 1].id);
              return;
            }
          }
          // If no previous slide with components was found, go to the previous slide itself.
          if (currentSlideIndex > 0) {
            scrollToElement(viewData.slides[currentSlideIndex - 1].id);
          }
        }
      }
    };

    switch (event.key) {
      case "ArrowRight":
        navigateSlides("right");
        break;
      case "ArrowLeft":
        navigateSlides("left");
        break;
      case "ArrowDown":
        navigateComponents("down");
        break;
      case "ArrowUp":
        navigateComponents("up");
        break;
      default:
        break;
    }
  };

  window.addEventListener("keydown", handleKeyDown);

  // The IntersectionObserver logic was here. It is removed because it works against the "URL as single source of truth" principle for navigation.

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
};
